export var FIELD_META_PROP = 'data-__meta';


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/form/constants.js
// module id = 321
// module chunks = 0